import { useMutation } from 'react-query';
import useIntl from '../../../hooks/useIntl';
import { toastr } from 'react-redux-toastr';
import messages from './messages';
import useSelectedProperty from '../../../hooks/useSelectedProperty';
import DocumentService from '../../../services/documentService';

const useDownloadResidentLetterPDF = (closeModal) => {
  const intl = useIntl();
  const { organizationId, id: propertyId, name } = useSelectedProperty();

  const mutation = useMutation(
    async ({ requestOptions, rentForecastId, rows, isPercent }) => {
      const service = new DocumentService();

      requestOptions.otherText = 'Other: ' + requestOptions.otherText;

      return service.saveResidentRdBudgetsLetter(
        organizationId,
        propertyId,
        rentForecastId,
        requestOptions,
        prepareRowsForBackend(rows, isPercent),
        name,
      );
    },
    {
      onSuccess: () => {
        toastr.success(
          intl.formatMessage(messages.residentLetterDownloadSuccess),
        );
        closeModal();
      },
      onError: (error) => {
        toastr.error(
          intl.formatMessage(messages.residentLetterDownloadError),
          null,
          { timeOut: 0, showCloseButton: true },
        );
      },
    },
  );

  return mutation;
};

function prepareRowsForBackend(rows, isPercent) {
  return rows
    .filter((row) => row.unitType?.value !== 'Z')
    .map((row) => ({
      brSize: row.bedsBaths?.value?.split('/')[0] ?? '',
      currentBasic: row.currentbasicRent?.value ?? 0,
      currentNote: row.currentnoteRent?.value ?? 0,
      newBasic: row.newbasicRent?.value ?? 0,
      newNote: row.newnoteRent?.value ?? 0,
      currentUA: row['currentRD Utility Allowance']?.value ?? 0,
      newUA: row['newRD Utility Allowance']?.value ?? 0,
      isPercent,
    }));
}

export default useDownloadResidentLetterPDF;
